// extracted by mini-css-extract-plugin
module.exports = {"speechBubble":"VerifiedBadge_speechBubble__KvZOi"};